import { FormikPasswordInput, FormikTextInput } from "@sso/components/Formik";
import { AuthKeys } from "@sso/constant";
import { Flex, GridItem } from "@sso/ui/FlexBox";

export const PersonalForm = () => {
  return (
    <>
      <Flex wrap="wrap" align="baseline">
        <GridItem xs={12} sm={6}>
          <FormikTextInput name={AuthKeys.FIRST_NAME} label="First Name" />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <FormikTextInput name={AuthKeys.LAST_NAME} label="Last Name" />
        </GridItem>
      </Flex>
      <FormikTextInput name={AuthKeys.USER_NAME} label="User Name" />
      <FormikTextInput name={AuthKeys.EMAIL} label="Email" />
      <FormikPasswordInput name={AuthKeys.PASSWORD} label="Password" showPasswordStrength />
      <FormikTextInput name={AuthKeys.CONFIRM_PASSWORD} label="Confirm Password" type="password" />
    </>
  );
};
